

























import 'reflect-metadata'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

@Component({})
export default class ValidatorPaginationControls extends Vue {
    @Prop() total!: number
    @Prop() limit!: number

    page = 1

    @Watch('page')
    onPageChanged(val: number) {
        const start = (val - 1) * this.limit
        this.$emit('change', start)
    }

    get totalPages(): number {
        return Math.ceil(this.total / this.limit)
    }

    pageUp(): void {
        const page = this.page + 1
        if (page > this.totalPages) return
        this.page = page
    }

    pageDown(): void {
        const page = this.page - 1

        if (page < 1) return
        this.page = page
    }
}
